import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

//FLN get api as activity type
export const getFaqQuizThunk = createAsyncThunk("faq/get", async (data) => {
  let response = await api.get(
    `getFaqSectionData/${data.usertype}/${data.sectionId}`
  );
  return response.data;
});

export const updateFaqQuizThunk = createAsyncThunk(
  "faq/update",
  async (body) => {
    let response = await api.put("updateFaqQuiz", body);
    return response.data;
  }
);

export const deleteFaqQuizThunk = createAsyncThunk(
  "faq/delete",
  async (body) => {
    let response = await api.delete("deleteFaqQuiz", body);
    return response.data;
  }
);
